import { CSP_NONCE, DOCUMENT, inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SecurityService {
  private nonce = inject(CSP_NONCE);
  private document = inject(DOCUMENT);
  private readonly NONCE_KEY = 'INSERT_NONCE';

  load() {
    const targetElements = this.document.querySelectorAll(`[nonce="${this.NONCE_KEY}"]`);
    targetElements.forEach((element) => {
      if (element.getAttribute('nonce') === this.NONCE_KEY) {
        element.setAttribute('nonce', this.nonce);
      }
    });

    const replay = this.document.querySelector(`[id="ng-event-dispatch-contract"]`);
    replay?.setAttribute('nonce', this.nonce);

    const state = this.document.querySelector(`[id="nxt-ecom-frontend-state"]`);
    state?.setAttribute('nonce', this.nonce);
  }
}

export const securityServiceFactory = (securityService: SecurityService) => {
  return () => {
    return securityService.load();
  };
};
